/*
  eslint-disable no-restricted-syntax, i18next/no-literal-string -- This is a test file and we will be updating this shortly
*/
import type { BaseTile } from "./types";

export const tiles: BaseTile[] = [
  {
    baseColSpan: 1,
    baseRowSpan: 3,
    children: (
      <div className="flex flex-col h-full">
        <div className="text-4xl md:text-5xl font-bold mb-2">1,112</div>
        <div className="text-sm text-white/60 mb-4">Total Post Created</div>
        <div className="flex-1 flex flex-col">
          <div className="text-xs text-white/50 mb-3">
            The impact you've made through every post you've shared
          </div>
          <div className="flex-1 bg-gray-700/30 rounded-xl p-4 relative overflow-hidden min-h-0">
            <div className="absolute inset-0 bg-gradient-to-br from-purple-500/20 to-pink-500/20" />
            <div className="relative h-full flex items-center justify-center">
              <div className="size-20 rounded-full bg-gray-600/40" />
            </div>
          </div>
        </div>
      </div>
    ),
    enabled: true,
    id: "total-posts",
  },
  {
    baseColSpan: 1,
    baseRowSpan: 3,
    children: (
      <div className="flex flex-col h-full">
        <div className="text-sm text-white/80 font-medium mb-4 text-center">
          Top contributor / most active member
        </div>
        <div className="flex-1 flex items-center justify-center min-h-0">
          <div className="relative flex items-center justify-center">
            <div className="size-24 rounded-full bg-gray-600/40 absolute left-[-40px]" />
            <div className="size-32 rounded-full bg-gray-500/40 z-10" />
            <div className="size-24 rounded-full bg-gray-600/40 absolute right-[-40px]" />
          </div>
        </div>
      </div>
    ),
    enabled: true,
    id: "top-contributor",
  },
  {
    baseColSpan: 1,
    baseRowSpan: 3,
    children: (
      <div className="flex flex-col h-full">
        <div className="text-sm text-white/80 font-medium mb-4 text-center">
          Most popular event (by attendance or engagement)
        </div>
        <div className="flex-1 flex items-end min-h-0">
          <div className="w-full bg-purple-900/30 rounded-xl p-4 border border-purple-500/20">
            <div className="flex items-start justify-between mb-3">
              <div className="bg-gray-600/40 size-10 rounded shrink-0" />
              <div className="flex flex-col gap-1 flex-1 ml-3">
                <div className="bg-gray-600/40 h-3 w-3/4 rounded mb-2" />
                <div className="bg-gray-600/40 h-2 w-full rounded mb-1" />
                <div className="bg-gray-600/40 h-2 w-3/4 rounded" />
              </div>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex -space-x-2">
                <div className="size-6 rounded-full bg-gray-600/40 border-2 border-purple-900/30" />
                <div className="size-6 rounded-full bg-gray-600/40 border-2 border-purple-900/30" />
              </div>
              <div className="bg-gray-600/40 h-6 w-16 rounded" />
            </div>
          </div>
        </div>
      </div>
    ),
    enabled: true,
    id: "popular-event",
  },
  {
    baseColSpan: 2,
    baseRowSpan: 2,
    children: (
      <div className="flex flex-col h-full">
        <div className="text-4xl md:text-5xl font-bold mb-2">3,735</div>
        <div className="text-sm text-white/60 mb-4">Total comments posted</div>
        <div className="flex-1 flex flex-col min-h-0">
          <div className="flex-1 bg-purple-900/30 rounded-xl p-4 border border-purple-500/20">
            <div className="flex items-start gap-3">
              <div className="size-8 rounded-full bg-gray-600/40 shrink-0" />
              <div className="flex-1">
                <div className="bg-gray-600/40 h-3 w-32 rounded mb-2" />
                <div className="bg-gray-600/40 h-2 w-full rounded mb-1" />
                <div className="bg-gray-600/40 h-2 w-3/4 rounded" />
              </div>
              <div className="bg-gray-600/40 size-6 rounded shrink-0" />
            </div>
            <div className="flex items-center gap-4 mt-3">
              <div className="bg-gray-600/40 h-2 w-12 rounded" />
              <div className="bg-gray-600/40 h-2 w-12 rounded" />
            </div>
          </div>
        </div>
      </div>
    ),
    enabled: true,
    id: "comments-posted",
  },
  {
    baseColSpan: 1,
    baseRowSpan: 2,
    children: (
      <div className="flex flex-col h-full">
        <div className="text-4xl md:text-5xl font-bold mb-2">17,124</div>
        <div className="text-sm text-white/60 mb-4">Total likes given</div>
        <div className="flex-1 min-h-0">
          <div className="bg-gray-700/30 rounded-xl h-full relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-red-500/20 to-pink-500/20" />
            <div className="relative h-full flex items-center justify-center gap-2 p-4">
              <div className="size-12 rounded-lg bg-gray-600/40" />
              <div className="size-6 rounded-full bg-gray-600/40" />
            </div>
          </div>
        </div>
      </div>
    ),
    enabled: true,
    id: "likes-given",
  },
];
